import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAuth, getUser } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, Printer } from "lucide-react";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (getUser()) { nav("/dashboard", { replace: true }); return; }
      try {
        const r = await api.get("/setup/status");
        if (r.data.setup_needed) nav("/setup", { replace: true });
      } catch {}
    })();
     
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, passwort: pw });
      setAuth(r.data.access_token, r.data.user);
      toast.success(`Willkommen, ${r.data.user.vorname}!`);
      nav("/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Anmeldung fehlgeschlagen.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <Card className="w-full max-w-md shadow-lg border-slate-200" data-testid="login-card">
        <CardHeader className="text-center space-y-3 pb-4">
          <div className="mx-auto w-12 h-12 rounded-xl bg-blue-600 flex items-center justify-center">
            <Printer className="w-6 h-6 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold tracking-tight">Anmeldung</CardTitle>
          <p className="text-sm text-slate-500">Die Druckexperten CRM</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="pw">Passwort</Label>
              <Input id="pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="login-passwort-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full" data-testid="login-submit-button">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Anmelden
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
